import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

// TODO: Reinstate this component in index, design-system-wc, storybook & storybook ng. Excluded now because of https://github.com/mui-org/material-ui-pickers/issues/1662
var DateTimePicker = function DateTimePicker(_ref) {
  var dsOnChange = _ref.dsOnChange,
      dsOnBlur = _ref.dsOnBlur,
      error = _ref.error,
      fullWidth = _ref.fullWidth,
      helperText = _ref.helperText,
      label = _ref.label,
      locale = _ref.locale,
      format = _ref.format,
      utils = _ref.utils,
      value = _ref.value,
      name = _ref.name,
      e2e = _ref.e2e,
      disabled = _ref.disabled,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      required = _ref.required;
  format = format || 'MM/dd/yyyy hh:mm a';
  utils = utils || MomentUtils;
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(MuiPickersUtilsProvider, {
      locale: locale,
      utils: utils
    }, /*#__PURE__*/React.createElement(KeyboardDateTimePicker, _extends({
      name: name,
      clearable: true,
      error: error,
      format: format,
      fullWidth: fullWidth,
      helperText: helperText,
      inputVariant: "outlined",
      label: label,
      onChange: dsOnChange,
      onBlur: dsOnBlur,
      size: "small",
      value: value,
      disabled: disabled,
      minDate: minDate,
      maxDate: maxDate,
      required: required
    }, e2e && {
      'data-e2e': e2e,
      inputProps: {
        'data-e2e': "".concat(e2e, "-input")
      },
      InputLabelProps: {
        'data-e2e': "".concat(e2e, "-label")
      }
    })))
  );
};

export default DateTimePicker;

try {
  DateTimePicker.__docgenInfo = {
    description: '',
    displayName: 'DateTimePicker',
    methods: [],
    props: {
      dsOnChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnChange',
        required: true,
        type: {
          name: '(date: Moment, value?: string) => void'
        }
      },
      dsOnBlur: {
        defaultValue: null,
        description: '',
        name: 'dsOnBlur',
        required: false,
        type: {
          name: 'FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>'
        }
      },
      locale: {
        defaultValue: null,
        description: '',
        name: 'locale',
        required: false,
        type: {
          name: 'any'
        }
      },
      utils: {
        defaultValue: null,
        description: '',
        name: 'utils',
        required: false,
        type: {
          name: 'any'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      disabled: {
        defaultValue: null,
        description: 'Disable picker and text field\n' + 'If `true`, the `input` element will be disabled.',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      fullWidth: {
        defaultValue: null,
        description: 'If `true`, the input will take up the full width of its container.',
        name: 'fullWidth',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      error: {
        defaultValue: null,
        description: 'If `true`, the label will be displayed in an error state.',
        name: 'error',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      label: {
        defaultValue: null,
        description: 'The label content.',
        name: 'label',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      name: {
        defaultValue: null,
        description: 'Name attribute of the `input` element.',
        name: 'name',
        required: false,
        type: {
          name: 'string'
        }
      },
      value: {
        defaultValue: null,
        description: 'Picker value',
        name: 'value',
        required: true,
        type: {
          name: 'ParsableDate'
        }
      },
      required: {
        defaultValue: null,
        description: 'If `true`, the label is displayed as required and the `input` element` will be required.',
        name: 'required',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      format: {
        defaultValue: null,
        description: 'Format string',
        name: 'format',
        required: false,
        type: {
          name: 'string'
        }
      },
      helperText: {
        defaultValue: null,
        description: 'The helper text content.',
        name: 'helperText',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      minDate: {
        defaultValue: {
          value: 'Date(1900-01-01)'
        },
        description: 'Min selectable date',
        name: 'minDate',
        required: false,
        type: {
          name: 'ParsableDate'
        }
      },
      maxDate: {
        defaultValue: {
          value: 'Date(2100-01-01)'
        },
        description: 'Max selectable date',
        name: 'maxDate',
        required: false,
        type: {
          name: 'ParsableDate'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map